import axios from "axios";
import axiosClient from "./axios";
import axiosImage from "./axiosImage";
const apiUrl = "https://be.jodi.ac/api";

export const userLoginWithSecret = async (email, secretKey) => {
  try {
    const response = await axios.post(apiUrl + "/auth/login", {
      email,
      secretKey,
    });
    return response.data;
  } catch (error) {
    console.error("Error logging in with secret:", error);
    throw error;
  }
};

export const pinLogin = async (id, secretKey) => {
  try {
    const response = await axios.post(apiUrl + "/auth/pinLogin", {
      id,
      secretKey,
    });
    return response.data;
  } catch (error) {
    console.error("Pin login error:", error);
    throw error;
  }
};

export const resetSecret = async (id, email) => {
  try {
    const response = await axios.post(apiUrl + "/auth/resetSecret", {
      id,
      email,
    });
    return response.data;
  } catch (error) {
    console.error("Reset secret error:", error);
    throw error;
  }
};

export const userRegister = async (
  email,
  password,
  password_confirmation,
  first_name,
  last_name,
  phone
) => {
  try {
    const response = await axios.post(apiUrl + "/register", {
      email,
      password,
      password_confirmation,
      first_name,
      last_name,
      phone,
    });
    return response.data;
  } catch (error) {
    console.error("Error logging in:", error);
    throw error;
  }
};



export const getUUID = async () => {
  try {
    const response = await axiosClient.get(`/user/getUUID`);
    return response.data.uuid;
  } catch (error) {
    console.error("UUID alınırken hata:", error);
    throw error;
  }
};


export const getVisionBoard = async (uuid) => {
  try {
    const response = await axiosClient.get(`/module/vision-board/` + uuid);
    return response.data;
  } catch (error) {
    console.error("Hayal pannosu alınırken hata:", error);
    throw error;
  }
};


export const getCurrentPackageUser = async (uuid) => {
  try {
    const response = await axios.get(apiUrl + `/getCurrentPackage/` + uuid);
    return response.data;
  } catch (error) {
    console.error("Mevcut paket kullanıcısı alınırken hata:", error);
    throw error;
  }
};


export const getCurrentPackageUserModule = async (moduleId, uuid) => {
  try {
    const response = await axiosClient.get(`/getPackageData/` + moduleId + `/` + uuid);
    return response.data;
  } catch (error) {
    console.error("Mevcut paket kullanıcısı alınırken hata:", error);
    throw error;
  }
};

export const postPinCode = async (data) => {
  try {
    const response = await axiosClient.post(`/verify/pinCode`, data);
    return response.data;
  } catch (error) {
    console.error("Pin kodu doğrulanırken hata:", error);
    throw error;
  }
};


export const postCreateProfile = async (data) => {
  try {
    const response = await axios.post(apiUrl + `/createProfile`, data);
    return response.data;
  } catch (error) {
    console.error("Email ayarlanırken hata:", error);
    throw error;
  }
};

export const getAllPackages = async () => {
  try {
    const response = await axiosClient.get(`/getAllPackages`);
    return response.data;
  } catch (error) {
    console.error("Paketler alınırken hata:", error);
    throw error;
  }
};
export const getProfile = async () => {
  try {
    const response = await axiosClient.get(`/profile`);
    return response.data;
  } catch (error) {
    console.error("Profil alınırken hata:", error);
    throw error;
  }
};

export const setUpdateProfile = async (data) => {
  try {
    const response = await axiosClient.put(`/profile/updateProfile`, data);
    return response.data;
  } catch (error) {
    console.error("Paket ayarlanırken hata:", error);
    throw error;
  }
};

export const setCurrentPackage = async (packageId) => {
  try {
    const response = await axiosClient.post(`/setCurrentPackage?currentPackage=${packageId}`);
    return response.data;
  } catch (error) {
    console.error("Paket ayarlanırken hata:", error);
    throw error;
  }
};

export const postVisionBoard = async (data) => {
  try {
    const response = await axiosClient.post(`/module/vision-board`, data);
    return response.data;
  } catch (error) {
    console.error("Hayal pannosu kaydedilirken hata:", error);
    throw error;
  }
};

export const deleteVisionBoardSingleImage = async (imagedId) => {
  try {
    const response = await axiosClient.delete(`/module/vision-board/image/` + imagedId);
    return response.data;
  } catch (error) {
    console.error("Hayal pannosu görseli silinirken hata:", error);
    throw error;
  }
};


export const getVisionBoardStockImages = async () => {
  try {
    const response = await axiosClient.get(`/module/vision-board/stock-gallery`);
    return response.data;
  } catch (error) {
    console.error("Hayal pannosu stok görselleri alınırken hata:", error);
    throw error;
  }
};

export const getVisionBoardUserUploads = async () => {
  try {
    const response = await axiosClient.get(`/module/vision-board/user-gallery`);
    return response.data;
  } catch (error) {
    console.error("Hayal pannosu kullanıcı yüklemeleri alınırken hata:", error);
    throw error;
  }
};


export const postVisionBoardUserUploads = async (image, title) => {
  try {
    const formData = new FormData();
    formData.append('image', image);
    formData.append('title', title);

    const response = await axiosImage.post(`/api/module/vision-board/upload-image`, formData);
    return response.data;
  } catch (error) {
    console.error("Hayal pannosu kullanıcı yüklemeleri kaydedilirken hata:", error);
    throw error;
  }
};




export const postJodiacRequest = async (data) => {
  try {
    const response = await axiosClient.post(`/module/request/send`, data);
    return response.data;
  } catch (error) {
    console.error("Jodiac isteği gönderilirken hata:", error);
    throw error;
  }
};



export const postJodiacRequestAccept = async (data) => {
  try {
    const response = await axiosClient.post(`/module/request/approve`, data);
    return response.data;
  } catch (error) {
    console.error("Jodiac isteği onaylanırken hata:", error);
    throw error;
  }
};

export const getMemoryTreeList = async () => {
  try {
    const response = await axiosClient.get(`/module/memory-tree/list`);
    return response.data;
  } catch (error) {
    console.error("Anı ağacı listesi alınırken hata:", error);
    throw error;
  }
};

export const getMemoryTreeSingle = async (uuid) => {
  try {
    const response = await axiosClient.get(`/module/memory-tree/` + uuid);
    return response.data;
  } catch (error) {
    console.error("Anı ağacı tekli alınırken hata:", error);
    throw error;
  }
};


export const postMemoryTreePhoto = async (uuid, file, { title, caption, memory_date } = {}) => {
  try {
    const formData = new FormData();
    if (file) formData.append('photo', file);
    if (title) formData.append('title', title);
    if (caption) formData.append('caption', caption);
    if (memory_date) formData.append('memory_date', memory_date);

    const response = await axiosImage.post(`/api/module/memory-tree/` + uuid + `/upload-photo`, formData);
    return response.data;
  } catch (error) {
    console.error("Anı ağacına fotoğraf yüklenirken hata:", error);
    throw error;
  }
};


export const getTimeCapsuleCoupleList = async () => {
  try {
    const response = await axiosClient.get(`/module/couple-time-capsule/list`);
    return response.data;
  } catch (error) {
    console.error("Zaman kapsülü listesi alınırken hata:", error);
    throw error;
  }
};


export const updateTimeCapsuleCouple = async (data, uuid) => {
  try {
    const response = await axiosClient.put(`/module/couple-time-capsule/` + uuid, data);
    return response.data;
  } catch (error) {
    console.error("Zaman kapsülü güncellenirken hata:", error);
    throw error;
  }
};

export const updateTimeCapsuleCoupleStart = async (uuid) => {
  try {
    const response = await axiosClient.put(`/module/couple-time-capsule/` + uuid + "/start");
    return response.data;
  } catch (error) {
    console.error("Zaman kapsülü güncellenirken hata:", error);
    throw error;
  }
};


export const unlockTimeCapsuleCouple = async (uuid) => {
  try {
    const response = await axiosClient.post(`/module/couple-time-capsule/` + uuid + "/unlock");
    return response.data;
  } catch (error) {
    console.error("Jodiac isteği onaylanırken hata:", error);
    throw error;
  }
};


export const postTimeCapsuleCouplePhoto = async (photo, uuid) => {
  try {
    const formData = new FormData();
    formData.append('photo', photo);

    const response = await axiosImage.post(`/api/module/couple-time-capsule/` + uuid + `/upload-photo`, formData);
    return response.data;
  } catch (error) {
    console.error("Zaman kapsülü fotoğrafı kaydedilirken hata:", error);
    throw error;
  }
};

export const getAffirmationSuggestionCategory = async () => {
  try {
    const response = await axiosClient.get(`/module/affirmation-suggestion/categories`);
    return response.data;
  } catch (error) {
    console.error("Olumlama önerisi kategori listesi alınırken hata:", error);
    throw error;
  }
};


export const getAffirmationSuggestion = async (slug) => {
  try {
    const response = await axiosClient.get(`/module/affirmation-suggestion/category/` + slug);
    return response.data;
  } catch (error) {
    console.error("Olumlama önerisi alınırken hata:", error);
    throw error;
  }
};




export const getMeditationRoom = async () => {
  try {
    const response = await axiosClient.get(`/module/meditation/room`);
    return response.data;
  } catch (error) {
    console.error("Meditation odası alınırken hata:", error);
    throw error;
  }
};



export const postMeditationStart = async () => {
  try {
    const response = await axiosClient.post(`/module/meditation/start`);
    return response.data;
  } catch (error) {
    console.error("Meditation başlatılırken hata:", error);
    throw error;
  }
};



export const postMeditationEnd = async () => {
  try {
    const response = await axiosClient.post(`/module/meditation/end`);
    return response.data;
  } catch (error) {
    console.error("Meditation bitirilirken hata:", error);
    throw error;
  }
};

export const getAffirmationsHistory = async () => {
  try {
    const response = await axiosClient.get(`/module/affirmations/history?days=${7}`);
    return response.data;
  } catch (error) {
    console.error("Olumlama geçmişi alınırken hata:", error);
    throw error;
  }
};

export const postAffirmationsLike = async (data) => {
  try {
    const response = await axiosClient.post(`/module/affirmations/like`, data);
    return response.data;
  } catch (error) {
    console.error("Olumlama beğenisi gönderilirken hata:", error);
    throw error;
  }
};

export const changePassword = async (passwordInDb, changedPasswordFirst, changedPasswordSecond) => {
  try {
    const response = await axiosClient.put(`/auth/changePassword`, {
      passwordInDb,
      changedPasswordFirst,
      changedPasswordSecond
    });
    return response.data;
  } catch (error) {
    console.error("Şifre değiştirilirken hata:", error);
    throw error;
  }
};

// Şifre sıfırlama linki gönderme
export const forgotPassword = async (email) => {
  try {
    const response = await axios.post(apiUrl + "/password/forgot", {
      email
    });
    return response.data;
  } catch (error) {
    console.error("Şifre sıfırlama linki gönderilirken hata:", error);
    throw error;
  }
};

// Token ile şifre sıfırlama
export const resetPassword = async (email, token, newPassword, confirmNewPassword) => {
  try {
    const response = await axios.post(apiUrl + "/password/reset", {
      email,
      token,
      newPassword,
      confirmNewPassword
    });
    return response.data;
  } catch (error) {
    console.error("Şifre sıfırlanırken hata:", error);
    throw error;
  }
};

// Mağaza API'leri
export const getStoreModules = async () => {
  try {
    const response = await axiosClient.get(`/store/modules`);
    return response.data;
  } catch (error) {
    console.error("Mağaza modülleri alınırken hata:", error);
    throw error;
  }
};

export const buyStoreModule = async (packageId) => {
  try {
    const response = await axiosClient.post(`/store/modules/buy`, {
      package_id: packageId
    });
    return response.data;
  } catch (error) {
    console.error("Modül satın alınırken hata:", error);
    throw error;
  }
};

// Human Chart API'leri
export const calculateHumanChart = async () => {
  try {
    const response = await axiosClient.post(`/module/humanchart/calculate`);
    return response.data;
  } catch (error) {
    console.error("Human Chart hesaplanırken hata:", error);
    throw error;
  }
};

export const getLatestHumanChart = async () => {
  try {
    const response = await axiosClient.get(`/module/humanchart/latest`);
    return response.data;
  } catch (error) {
    console.error("En son Human Chart alınırken hata:", error);
    throw error;
  }
};

// Transit Analysis API'leri
export const getTransitAnalysis = async (type) => {
  try {
    const response = await axiosClient.get(`/module/transit-analysis?type=${type}`);
    return response.data;
  } catch (error) {
    console.error("Transit analizi alınırken hata:", error);
    throw error;
  }
};

export const postTransitAnalysis = async (type) => {
  try {
    const response = await axiosClient.post(`/module/transit-analysis`, { type });
    return response.data;
  } catch (error) {
    console.error("Transit analizi oluşturulurken hata:", error);
    throw error;
  }
};



